import React from 'react';
import { oneOf, string } from 'prop-types';
import classNames from 'classnames';

import { Logo, ExternalLink } from '../../components';

import css from './LinkedLogo.module.css';

// const isDevServer = !!process.env.REACT_APP_IS_DEV_SERVER;

const LinkedLogo = props => {
  const { className, rootClassName, logoClassName, format, alt, isAuthenticated, ...rest } = props;

  const classes = classNames(rootClassName || css.root, className);
  // Always link to the marketing site, for both logged-in and anonymous users
  // return isDevServer ? (
  //   <NamedLink className={classes} name="LandingPage" {...rest}>
  //     <Logo
  //       format={format}
  //       className={
  //         logoClassName || classNames(css.logo, { [css.authenticatedLogo]: isAuthenticated })
  //       }
  //       alt={alt}
  //     />
  //   </NamedLink>
  // ) : (
  return (
    <ExternalLink className={classes} href="https://www.adventurely.app" target="_self">
      <Logo
        format={format}
        className={
          logoClassName || classNames(css.logo, { [css.authenticatedLogo]: isAuthenticated })
        }
        alt={alt}
      />
    </ExternalLink>
  );
};

LinkedLogo.defaultProps = {
  className: null,
  rootClassName: null,
  logoClassName: null,
  format: 'desktop',
};

LinkedLogo.propTypes = {
  className: string,
  rootClassName: string,
  logoClassName: string,
  format: oneOf(['desktop', 'mobile']),
};

export default LinkedLogo;
